import React, {Fragment} from 'react';
import connect from "react-redux/es/connect/connect";
import {bindActionCreators} from "redux";

import {fetchUserFollowers, resetUserFollowers} from "../../../../creators/user.followers";

import {SpinLoader} from "../../../components/Loader";
import Modal from "../../../components/Modal";
import FollowersList from "../../../components/FollowersList";


class Followers extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            toggleUserStatListFollower: false
        };

    }

    componentDidMount() {
        this.props.fetchUserFollowers(this.props.user._id);

    }

    componentWillUnmount() {
        this.props.resetUserFollowers();
    }

    render() {
        return (
            <Fragment>
                <div
                    className={`followers-count column my-16 ${this.props.userFollowersTotal >= 1 ? 'cursor-pointer' : ''}`}
                    onClick={() => this.props.userFollowersTotal >= 1 && this.setState({toggleUserStatListFollower: true})}>
                    {!this.props.userFollowersInitialized ? (
                        <span className="followers-number">0</span>
                    ) : (
                        <Fragment>
                            {!this.props.userFollowersLoading ?
                                <span className="followers-number">{this.props.userFollowersTotal || 0}</span> :
                                <SpinLoader className={"small"}/>}
                        </Fragment>
                    )}
                    <span className="followers-text">suiveur{this.props.userFollowersTotal >= 2 && 's'}</span>
                </div>
                <Modal toggle={this.state.toggleUserStatListFollower}
                       handleClose={() => this.setState({toggleUserStatListFollower: false})}>
                    <FollowersList User={this.props.user}
                                   handleClose={() => this.setState({toggleUserStatListFollower: false})} />
                </Modal>
            </Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        userFollowers: state.userFollowers.data,
        userFollowersLoading: state.userFollowers.loading,
        userFollowersInitialized: state.userFollowers.initialized,
        userFollowersTotal: state.userFollowers.total
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchUserFollowers,
    resetUserFollowers
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Followers);